/* Pawfy: detalles divertidos (sin afectar al rendimiento).
   1) Dibujos flotantes con profundidad al hacer scroll.
   2) Trazo "a mano" que se dibuja bajo los títulos de sección al llegar a ellos.
   3) Explosión de huellitas al pulsar los botones principales. */
(function () {
  /* Marca las páginas de chapas (los colores reducidos de la letra solo se aplican a ellas) */
  if (/\/products\/chapas?-/.test(location.pathname)) document.documentElement.classList.add('pawfy-es-chapa');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* 1) Profundidad: cada dibujo se desplaza en vertical según data-depth */
  var flotantes = [];
  function recoger() { flotantes = Array.prototype.slice.call(document.querySelectorAll('.pawfy-float .pf[data-depth]')); }
  var tick = false;
  function mover() {
    tick = false;
    var vh = window.innerHeight;
    flotantes.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var centro = box.top + box.height / 2 - vh / 2;
      var py = Math.max(-30, Math.min(30, -centro * Number(el.dataset.depth) * 0.15));
      el.style.setProperty('--py', py.toFixed(1) + 'px');
    });
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(mover); } }, { passive: true });

  /* 2) Trazo bajo los títulos */
  var TRAZO = '<svg class="pawfy-squiggle" viewBox="0 0 120 14" preserveAspectRatio="none" aria-hidden="true"><path pathLength="1" d="M3 9c12-6 22-6 32-1s20 5 30 0 20-6 30-1 15 4 22 1" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/></svg>';
  /* Círculo "a rotulador" alrededor de la última palabra (título de colecciones) */
  var CIRCULO = '<svg class="pawfy-circle" viewBox="0 0 200 80" preserveAspectRatio="none" aria-hidden="true"><path pathLength="1" d="M150 9C92-1 18 10 10 39c-7 27 66 37 122 33 52-4 66-26 56-44-9-17-60-22-118-12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>';
  var io = null;
  function observar(t) {
    if (!('IntersectionObserver' in window)) { t.classList.add('is-drawn'); return; }
    /* Se dibuja al verse bien y se borra cuando sale del todo de la pantalla,
       así vuelve a dibujarse cada vez que se pasa por él (sin moverse mientras se lee) */
    if (!io) io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.intersectionRatio >= 0.6) e.target.classList.add('is-drawn');
        else if (!e.isIntersecting) e.target.classList.remove('is-drawn');
      });
    }, { threshold: [0, 0.6] });
    io.observe(t);
  }
  function trazos() {
    /* Subrayado solo en "Los favoritos" y en "Crea un arnés…" */
    document.querySelectorAll('.pawfy-fav .pawfy-sec__title, .pawfy-crea__title').forEach(function (t) {
      if (t.querySelector('.pawfy-squiggle')) return;
      t.classList.add('pawfy-has-squiggle');
      t.insertAdjacentHTML('beforeend', TRAZO);
      observar(t);
    });
    /* Colecciones: la última palabra del título gira como una tragaperras y se pega como pegatina */
    document.querySelectorAll('.pawfy-sec__title').forEach(function (t) {
      var sec = t.closest('.pawfy-sec');
      if (!sec || !sec.querySelector('.pawfy-deck, .pawfy-rail') || t.querySelector('.pawfy-mix')) return;
      var txt = t.textContent.trim(), i = txt.lastIndexOf(' ');
      if (i < 0) return;
      var palabra = txt.slice(i + 1);
      t.textContent = txt.slice(0, i + 1);
      var w = document.createElement('span');
      w.className = 'pawfy-mix';
      var esc = palabra.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
      w.innerHTML =
        '<span class="pawfy-mix__slot" aria-hidden="true"><span class="pawfy-mix__reel">' +
        '<span>look</span><span class="pawfy-mix--serif">' + esc + '</span><span>rollo</span>' +
        '<span class="pawfy-mix--mano">' + esc + '</span><span>flow</span><span class="pawfy-mix--linea">' + esc + '</span><span>' + esc + '</span>' +
        '</span></span><span class="pawfy-mix__st">' + esc + '</span>';
      t.appendChild(w);
      tragaperras(w, palabra);
    });
  }

  /* Colecciones: gira, frena con un pequeño rebote y la palabra se pega de golpe como pegatina (¡plas!).
     Se queda pegada unos segundos y vuelve a empezar, solo mientras se ve la sección. */
  function tragaperras(w, palabra) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { w.classList.add('is-pegada'); return; }
    if (!document.getElementById('pawfy-fuentes-estilo')) {
      var l = document.createElement('link');
      l.id = 'pawfy-fuentes-estilo';
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@700&family=DM+Serif+Display:ital@1&display=swap&text=' + encodeURIComponent(palabra);
      document.head.appendChild(l);
    }
    var reel = w.querySelector('.pawfy-mix__reel'), n = reel.children.length - 1, visible = false, espera = null;
    function vuelta() {
      espera = null;
      if (!visible) return;
      w.classList.remove('is-pegada');
      reel.style.transition = 'none';
      reel.style.transform = 'translateY(0)';
      void reel.offsetWidth;
      reel.style.transition = 'transform 1.8s cubic-bezier(.45,0,.3,1.35)';
      reel.style.transform = 'translateY(' + (-n * 1.25) + 'em)';
      espera = setTimeout(function () {
        w.classList.add('is-pegada');
        espera = setTimeout(vuelta, 6500);
      }, 1800);
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (visible && !espera) vuelta();
      });
    }, { threshold: 0.4 }).observe(w);
  }

  /* 3) Huellitas al pulsar */
  function huellitas(x, y) {
    for (var i = 0; i < 7; i++) {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('class', 'pawfy-burst');
      s.setAttribute('aria-hidden', 'true');
      var u = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      u.setAttribute('href', '#pd-paw-solid');
      s.appendChild(u);
      var ang = (Math.PI * 2 * i) / 7 + Math.random() * 0.5;
      var dist = 40 + Math.random() * 35;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
      s.style.setProperty('--dy', Math.sin(ang) * dist - 20 + 'px');
      s.style.setProperty('--rot', (Math.random() * 80 - 40) + 'deg');
      s.style.color = i % 2 ? '#141414' : '#d93466';
      document.body.appendChild(s);
      setTimeout(function (el) { el.remove(); }, 900, s);
    }
  }
  /* Mimos: tocar la foto del banner lanza corazones que suben desde el dedo */
  function corazones(x, y) {
    for (var i = 0; i < 9; i++) {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('class', 'pawfy-burst');
      s.setAttribute('aria-hidden', 'true');
      var u = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      u.setAttribute('href', '#pd-heart-solid');
      s.appendChild(u);
      var tam = 1.4 + Math.random() * 1.4;
      s.style.width = s.style.height = tam + 'rem';
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--dx', (Math.random() * 140 - 70) + 'px');
      s.style.setProperty('--dy', -(70 + Math.random() * 110) + 'px');
      s.style.setProperty('--rot', (Math.random() * 50 - 25) + 'deg');
      s.style.animationDuration = (0.9 + Math.random() * 0.5) + 's';
      s.style.color = i % 3 === 0 ? '#ffffff' : '#d93466';
      document.body.appendChild(s);
      setTimeout(function (el) { el.remove(); }, 1500, s);
    }
  }
  document.addEventListener('click', function (e) {
    var foto = e.target.closest('.pawfy-hero__media');
    if (!foto || e.target.closest('a')) return;
    corazones(e.clientX, e.clientY);
    var pista = foto.querySelector('.pawfy-hero__hint');
    if (pista) pista.classList.add('is-hidden');
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pawfy-btn, .product-form__submit, .pawfy-sticky__btn, .cart__checkout-button');
    if (!b) return;
    var x = e.clientX, y = e.clientY;
    if (!x && !y) { var r = b.getBoundingClientRect(); x = r.left + r.width / 2; y = r.top + r.height / 2; }
    huellitas(x, y);
  }, true);

  /* 4) El cartel del pack del banner sigue un poco al cursor (solo con ratón) */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mousemove', function (e) {
      var tag = document.querySelector('[data-pawfy-follow]');
      if (!tag) return;
      var zona = tag.parentElement.getBoundingClientRect();
      if (e.clientY < zona.top || e.clientY > zona.bottom || e.clientX < zona.left || e.clientX > zona.right) {
        tag.style.setProperty('--fx', '0px'); tag.style.setProperty('--fy', '0px'); return;
      }
      var dx = (e.clientX - (zona.left + zona.width / 2)) / zona.width;
      var dy = (e.clientY - (zona.top + zona.height / 2)) / zona.height;
      tag.style.setProperty('--fx', (dx * 16).toFixed(1) + 'px');
      tag.style.setProperty('--fy', (dy * 12).toFixed(1) + 'px');
    }, { passive: true });
  }

  /* 5) Categorías: al llegar, la fila se desliza un poco y vuelve, para indicar que hay más */
  function pistaCategorias() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-pawfy-cat]').forEach(function (t) {
      if (t.dataset.pista || t.scrollWidth <= t.clientWidth + 10) return;
      t.dataset.pista = '1';
      var obs = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        obs.disconnect();
        setTimeout(function () {
          t.scrollBy({ left: 80, behavior: 'smooth' });
          setTimeout(function () { t.scrollTo({ left: 0, behavior: 'smooth' }); }, 800);
        }, 500);
      }, { threshold: 0.8 });
      obs.observe(t);
    });
  }

  /* 6) Tarjetas de producto en pantallas táctiles: la foto pasa sola a la segunda y vuelve
        (unos 4 s en cada una), solo mientras la tarjeta se ve, y cada una a su ritmo */
  var alternas = null;
  function fotosAlternas() {
    if (!window.matchMedia('(hover: none)').matches || !('IntersectionObserver' in window)) return;
    if (!alternas) {
      alternas = { visibles: new Set() };
      alternas.obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var c = e.target;
          if (e.intersectionRatio >= 0.6) {
            if (!alternas.visibles.has(c)) {
              var espera = 1200 + Math.random() * 2800;
              c._siguiente = Date.now() + espera;
              c.style.setProperty('--fill', Math.round(espera) + 'ms'); /* la barrita se llena al ritmo del cambio */
              c.classList.add('is-on');
              /* Safari no carga la 2.ª foto "perezosa" mientras está escondida: se pide ya */
              var f2 = c.querySelector('.pawfy-pcard__img--2');
              if (f2 && f2.loading === 'lazy') f2.loading = 'eager';
            }
            alternas.visibles.add(c);
          } else if (!e.isIntersecting) {
            alternas.visibles.delete(c);
            c.classList.remove('is-alt', 'is-on');
          }
        });
      }, { threshold: [0, 0.6] });
      setInterval(function () {
        var ahora = Date.now();
        alternas.visibles.forEach(function (c) {
          if (ahora >= c._siguiente) {
            var f2 = c.querySelector('.pawfy-pcard__img--2');
            /* solo se pasa a la 2.ª foto cuando ya está cargada; si no, se espera un poco */
            if (!c.classList.contains('is-alt') && f2 && !(f2.complete && f2.naturalWidth > 0)) { f2.loading = 'eager'; c._siguiente = ahora + 500; return; }
            c.style.setProperty('--fill', '4000ms'); c.classList.toggle('is-alt'); c._siguiente = ahora + 4000;
          }
        });
      }, 500);
    }
    document.querySelectorAll('.pawfy-pcard').forEach(function (c) {
      if (c.dataset.alt || !c.querySelector('.pawfy-pcard__img--2')) return;
      c.dataset.alt = '1';
      alternas.obs.observe(c);
    });
  }

  /* 7) Instagram: las fotos (de la app Instafeed, que llegan tarde) pasan solas en una tira sin fin.
        Se duplican para que el bucle no tenga corte; las copias abren el perfil de Instagram.
        En móvil se para mientras se toca. */
  /* La app carga cada foto cuando entra en pantalla (data-instafeed-src); en la tira se cargan todas ya */
  function fotosReales(raiz) {
    raiz.querySelectorAll('img[data-instafeed-src]').forEach(function (im) {
      var real = im.getAttribute('data-instafeed-src');
      if (real && im.getAttribute('src') !== real && !/instagram-icon/.test(im.getAttribute('src') || '')) im.setAttribute('src', real);
    });
  }
  function instaTira() {
    var w = document.querySelector('#insta-feed .instafeed-new-layout-wrapper');
    if (!w) return false;
    if (w.dataset.tira) { fotosReales(w); return true; }
    fotosReales(w);
    var items = Array.prototype.slice.call(w.querySelectorAll('.instafeed-new-layout-item'));
    if (items.length < 3) return false;
    w.dataset.tira = '1';
    var perfil = (document.querySelector('#insta-feed .instafeed-bottom-link-wrapper a') || {}).href;
    var pista = document.createElement('div');
    pista.className = 'pawfy-insta-track';
    items.forEach(function (i) { pista.appendChild(i); });
    items.forEach(function (i) {
      var copia = i.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      if (perfil) copia.addEventListener('click', function () { window.open(perfil, '_blank', 'noopener'); });
      pista.appendChild(copia);
    });
    w.appendChild(pista);
    w.classList.add('pawfy-insta-on');
    moverInsta(w, pista, items.length);
    return true;
  }

  /* Tira de Instagram: avanza sola y también se puede arrastrar con el dedo (o el ratón) hacia los lados,
     con inercia al soltar. Es un bucle: al llegar a las copias vuelve al principio sin que se note. */
  function moverInsta(w, pista, n) {
    pista.classList.add('is-js');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conRaton = window.matchMedia('(hover: hover)').matches;
    var x = 0, v = 0, ultimo = 0, arrastra = false, x0 = 0, p0 = 0, py0 = 0, movido = 0, hasta = 0, horizontal = null;
    var historial = [];
    function vuelta() {
      var a = pista.children[0], b = pista.children[n];
      return a && b ? b.offsetLeft - a.offsetLeft : pista.scrollWidth / 2;
    }
    function ajusta() {
      var mitad = vuelta();
      if (mitad > 0) { while (x <= -mitad) x += mitad; while (x > 0) x -= mitad; }
      pista.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function paso(t) {
      var dt = ultimo ? Math.min(t - ultimo, 64) : 16;
      ultimo = t;
      if (!arrastra) {
        if (Math.abs(v) > 0.02) { x += v * dt; v *= Math.pow(0.95, dt / 16); }
        else if (!reduce && t > hasta && !(conRaton && w.matches(':hover'))) {
          var mitad = vuelta();
          x -= (mitad / (window.innerWidth < 750 ? 40000 : 50000)) * dt;
        }
        ajusta();
      }
      requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);

    w.style.touchAction = 'pan-y';
    w.addEventListener('pointerdown', function (e) {
      arrastra = true; horizontal = null; v = 0; movido = 0;
      x0 = x; p0 = e.clientX; py0 = e.clientY; historial = [[e.timeStamp, e.clientX]];
    });
    w.addEventListener('pointermove', function (e) {
      if (!arrastra) return;
      var dx = e.clientX - p0, dy = e.clientY - py0;
      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horizontal = Math.abs(dx) > Math.abs(dy);
      if (horizontal === false) { arrastra = false; return; }
      if (!horizontal) return;
      try { if (w.setPointerCapture && !w.hasPointerCapture(e.pointerId)) w.setPointerCapture(e.pointerId); } catch (err) {}
      movido = Math.max(movido, Math.abs(dx));
      x = x0 + dx;
      ajusta();
      historial.push([e.timeStamp, e.clientX]);
      if (historial.length > 5) historial.shift();
    });
    function suelta() {
      if (!arrastra) return;
      arrastra = false;
      var h0 = historial[0], h1 = historial[historial.length - 1];
      v = h1 && h0 && h1[0] > h0[0] ? (h1[1] - h0[1]) / (h1[0] - h0[0]) : 0;
      hasta = performance.now() + 2500;
    }
    w.addEventListener('pointerup', suelta);
    w.addEventListener('pointercancel', suelta);
    /* Si se ha arrastrado, no se abre la publicación al soltar */
    w.addEventListener('click', function (e) { if (movido > 8) { e.preventDefault(); e.stopPropagation(); movido = 0; } }, true);
    w.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  /* Dibujos de raza (JPG con fondo blanco): se borra el blanco que toca los bordes, sin entrar en el dibujo,
     para que quede recortado encima del color. Se guarda el resultado para no repetirlo. */
  var sinFondo = {}, recortando = {};
  function quitarBlanco(url, listo) {
    if (sinFondo[url] || recortando[url]) return;
    recortando[url] = true;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = im.naturalWidth, h = im.naturalHeight, cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        var cx = cv.getContext('2d');
        cx.drawImage(im, 0, 0);
        var datos = cx.getImageData(0, 0, w, h), px = datos.data, visto = new Uint8Array(w * h), pila = [];
        /* Solo blanco puro (el pelo crema del westie se queda) y sin empezar por abajo (el pecho del chihuahua toca el borde) */
        var blanco = function (i) { return px[i * 4] >= 247 && px[i * 4 + 1] >= 247 && px[i * 4 + 2] >= 247; };
        for (var x = 0; x < w; x++) { pila.push(x); }
        for (var y = 0; y < h; y++) { pila.push(y * w, y * w + w - 1); }
        while (pila.length) {
          var i = pila.pop();
          if (visto[i] || !blanco(i)) continue;
          visto[i] = 1;
          px[i * 4 + 3] = 0;
          var col = i % w;
          if (col > 0) pila.push(i - 1);
          if (col < w - 1) pila.push(i + 1);
          if (i >= w) pila.push(i - w);
          if (i < w * (h - 1)) pila.push(i + w);
        }
        cx.putImageData(datos, 0, 0);
        sinFondo[url] = cv.toDataURL('image/png');
      } catch (e) { sinFondo[url] = url; }
      listo();
    };
    im.onerror = function () { sinFondo[url] = url; listo(); };
    im.src = url;
  }

  /* Chapas: vista previa orientativa del color de fondo (forma + color + nombre como en las fotos de producto) */
  function chapaPrevia() {
    var cajas = document.querySelectorAll('.ymq-options-box');
    if (!cajas.length) return;
    /* Opciones ocultas al cliente ("_Color de fondo"): se muestra el título sin el guion bajo */
    cajas.forEach(function (b) {
      var l = b.querySelector('.ymq_lable');
      if (l && /^_/.test(l.textContent.trim())) l.textContent = l.textContent.trim().slice(1);
    });
    var caja = function (re) {
      return Array.prototype.find.call(cajas, function (b) { return re.test(b.dataset.label || ''); });
    };
    /* "Color de fondo" en la chapa con foto, "Fondo" en la chapa con dibujo de raza */
    var color = caja(/^_?(color de )?fondo$/i);
    /* Chapas de diseño: no eligen fondo, pero sí "Color de letra" (círculos) y "Tipo de letra" */
    var cLetra = caja(/^color de letra$/i), tLetra = caja(/^tipo de letra$/i);
    /* Solo en las chapas (los arneses y packs también tienen letra y color para el nombre, pero no son chapas) */
    var esChapa = /\/products\/chapas?-/.test(location.pathname);
    var modoLetra = !color && esChapa && cLetra && tLetra && cLetra.querySelector('input[type=radio]');
    if (!color && !modoLetra) return;
    var ancla = color || tLetra;
    if (ancla.closest('.ymq-box').querySelector('.pawfy-chapa')) return;
    var forma = caja(/^forma$/i), nombre = caja(/^nombre/i), tipo = caja(/tipo de fondo/i), diseno = caja(/^dise(ñ|n)o$/i), raza = caja(/dibujo/i);
    /* Cada diseño enseña su foto de ejemplo del producto (por el nombre del archivo) */
    var FOTOS = { topos: 'chapafotoperro', rayos: 'chapachihuahua', puntos: 'chapateckellunares', 'dálmata': 'chapadalmataperro', dalmata: 'chapadalmataperro' };
    var ultimo = '';
    if (!document.getElementById('pawfy-fuente-chapa')) {
      var l = document.createElement('link');
      l.id = 'pawfy-fuente-chapa';
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Sniglet:wght@800&display=swap';
      document.head.appendChild(l);
      /* Las tres letras reales de las chapas (Letra 1 Foo, Letra 2 RF Krabuler, Letra 3 KG HAPPY Solid), en assets junto a este archivo */
      var js = document.querySelector('script[src*="pawfy-fun.js"]'), base = js ? js.src.replace(/pawfy-fun\.js.*$/, '') : '';
      var st = document.createElement('style');
      st.textContent = [1, 2, 3].map(function (n) {
        return "@font-face{font-family:'Pawfy Letra " + n + "';src:url('" + base + 'pawfy-letra-' + n + ".woff2') format('woff2');font-display:swap}";
      }).join('');
      document.head.appendChild(st);
    }
    var card = document.createElement('div');
    card.className = 'pawfy-chapa';
    card.innerHTML =
      '<div class="pawfy-chapa__lienzo"><svg viewBox="0 0 240 210" aria-hidden="true"></svg><img alt="" hidden></div>' +
      '<div class="pawfy-chapa__txt"><strong></strong><span></span></div>';
    (tipo || ancla).parentNode.insertBefore(card, tipo || ancla);
    var svg = card.querySelector('svg'), foto = card.querySelector('img');
    var titulo = card.querySelector('strong'), aviso = card.querySelector('.pawfy-chapa__txt span');

    /* Busca la foto del producto de ese diseño; si la encuentra, la pone en la vista previa y en la galería */
    function fotoDiseno(d) {
      var clave = FOTOS[d.toLowerCase()];
      if (!clave) return null;
      var imgs = document.querySelectorAll('media-gallery [data-media-id] img');
      for (var i = 0; i < imgs.length; i++) {
        if ((imgs[i].currentSrc || imgs[i].src).toLowerCase().indexOf(clave) > -1) return imgs[i];
      }
      return null;
    }

    function valor(b, sel) {
      if (!b) return '';
      var i = b.querySelector(sel || 'input:checked');
      return i ? (i.value || '').trim() : '';
    }
    function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* Forma de la chapa: círculo con anilla o hueso como el de las fotos */
    function siluetaDe(hueso) {
      return hueso
        ? '<circle cx="50" cy="84" r="34"/><circle cx="50" cy="146" r="34"/><circle cx="190" cy="84" r="34"/><circle cx="190" cy="146" r="34"/>' +
          '<path d="M44 66C90 84 150 84 196 66L196 164C150 146 90 146 44 164Z"/>'
        : '<circle cx="120" cy="122" r="82"/><circle cx="120" cy="36" r="24"/><rect x="96" y="36" width="48" height="40"/>';
    }

    /* Chapas de diseño: el nombre con el color y la letra elegidos (el fondo será el diseño de la chapa) */
    var LETRAS = { 1: "'Pawfy Letra 1',sans-serif", 2: "'Pawfy Letra 2',sans-serif", 3: "'Pawfy Letra 3',sans-serif" };
    var letrasListas = false;
    /* Fondo real del diseño: si en Contenido > Archivos existe "fondo-<handle del producto>.png" (o .jpg),
       se usa dentro de la chapa; si no, se queda el fondo crema con puntitos.
       Si la chapa tiene una opción de color del diseño (p. ej. "Color Vichy"), primero se busca
       "fondo-<handle>-<color>.png" (fondo-chapa-vichy-lila.png) para que cambie al elegir otro color */
    var colorDis = caja(/^color (?!de letra)/i);
    var fondoReal = '', fondos = {}, tonos = {};
    /* Borde de la letra blanca: el color medio del fondo, oscurecido (como en las chapas de verdad) */
    function tonoOscuro(im) {
      try {
        var cv = document.createElement('canvas'), g = cv.getContext('2d');
        cv.width = cv.height = 24;
        g.drawImage(im, 0, 0, 24, 24);
        var d = g.getImageData(0, 0, 24, 24).data, s = [0, 0, 0], n = 0;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i] + d[i + 1] + d[i + 2] > 720) continue; /* el blanco del fondo no cuenta */
          s[0] += d[i]; s[1] += d[i + 1]; s[2] += d[i + 2]; n++;
        }
        if (!n) return '';
        return 'rgb(' + s.map(function (v) { return Math.round(v / n * 0.55); }).join(',') + ')';
      } catch (e) { return ''; }
    }
    function buscarFondo() {
      var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (!h) return;
      var c = valor(colorDis).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (c in fondos) { fondoReal = fondos[c]; return; }
      fondos[c] = fondoReal;
      var urls = (c ? ['fondo-' + h + '-' + c + '.png', 'fondo-' + h + '-' + c + '.jpg'] : []).concat(['fondo-' + h + '.png', 'fondo-' + h + '.jpg']), k = 0;
      (function prueba() {
        if (k >= urls.length) return;
        var url = '/cdn/shop/files/' + urls[k++] + '?width=600', im = new Image();
        im.onload = function () { fondos[c] = url; tonos[url] = tonoOscuro(im); pintar(); };
        im.onerror = prueba;
        im.src = url;
      })();
    }
    function pintarLetra() {
      buscarFondo();
      card.hidden = false;
      titulo.textContent = ((window.pawfyT || {}).nombreTit || 'Mira cómo queda el nombre');
      aviso.textContent = ((window.pawfyT || {}).letraTxt || 'Vista previa orientativa del color y la letra. El fondo será el diseño de esta chapa.');
      var hueso = /hueso/i.test(valor(forma));
      var marcado = cLetra.querySelector('input:checked'), circulo = marcado && marcado.nextElementSibling;
      var tinta = (circulo && circulo.style.backgroundColor) || '#141414';
      var m = /(\d)/.exec(valor(tLetra)), n = m ? +m[1] : 2, fuente = LETRAS[n] || LETRAS[2];
      var nom = esc((valor(nombre, 'input[type=text]') || 'Bimba').slice(0, 12));
      /* El SVG no se repinta solo cuando llega la letra: se vuelve a pintar al cargarse */
      if (!letrasListas && document.fonts && document.fonts.load) {
        letrasListas = true;
        Promise.all([1, 2, 3].map(function (k) { return document.fonts.load("36px 'Pawfy Letra " + k + "'"); })).then(pintar, function () {});
      }
      /* Borde blanco como en las fotos; si la letra es blanca o muy clara, el borde es oscuro */
      var rgb = /(\d+),\s*(\d+),\s*(\d+)/.exec(tinta), claraLetra = rgb && (0.299 * rgb[1] + 0.587 * rgb[2] + 0.114 * rgb[3]) > 215;
      var tam = (hueso ? 40 : 48) * ({ 1: 0.95, 2: 1.05, 3: 0.7 }[n] || 1);
      var patron = fondoReal
        ? '<pattern id="pawfy-diseno" width="240" height="210" patternUnits="userSpaceOnUse"><image href="' + fondoReal + '" width="240" height="210" preserveAspectRatio="xMidYMid slice"/></pattern>'
        : '<pattern id="pawfy-diseno" width="22" height="22" patternUnits="userSpaceOnUse"><rect width="22" height="22" fill="#f3ece3"/><circle cx="6" cy="6" r="2.2" fill="#e4d8ca"/><circle cx="17" cy="16" r="2.2" fill="#e4d8ca"/></pattern>';
      aviso.textContent = fondoReal ? ((window.pawfyT || {}).letraFondoTxt || 'Vista previa orientativa del diseño con el color y la letra que elijas.') : aviso.textContent;
      svg.innerHTML =
        '<defs>' + patron + '</defs>' +
        '<g fill="url(#pawfy-diseno)">' + siluetaDe(hueso) + '</g>' +
        (hueso ? '<circle cx="120" cy="90" r="7" fill="#fff" stroke="rgba(0,0,0,.18)"/>' : '<circle cx="120" cy="34" r="9" fill="#fff" stroke="rgba(0,0,0,.18)"/>') +
        '<text x="120" y="' + (hueso ? 128 : 136) + '" text-anchor="middle" class="pawfy-chapa__nom" style="font-family:' + fuente + ';font-size:' + Math.round(tam) + 'px;fill:' + tinta + ';stroke:' + (claraLetra ? (tonos[fondoReal] || '#141414') : '#fff') + '">' + nom + '</text>';
      /* Si el nombre es largo y se sale de la chapa, se reduce hasta que quepa */
      var txt = svg.querySelector('text'), maxAncho = hueso ? 180 : 150;
      try {
        var ancho = txt.getBBox().width;
        if (ancho > maxAncho) txt.style.fontSize = Math.floor(tam * maxAncho / ancho) + 'px';
      } catch (e) {}
      card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop');
    }

    /* Letra blanca: se avisa debajo de los colores de que lleva borde negro para que se lea */
    var notaBlanco = null;
    function avisoBlanco() {
      if (!cLetra || !esChapa) return;
      if (!notaBlanco) {
        var lang = (document.documentElement.lang || 'es').slice(0, 2);
        notaBlanco = document.createElement('p');
        notaBlanco.className = 'pawfy-chapa__nota';
        notaBlanco.style.cssText = 'margin:.8rem 0 0;font-size:1.3rem;line-height:1.4;color:#555';
        notaBlanco.textContent = { en: 'White letters get an outline in a darker shade of the background so the name is easy to read.', pt: 'A letra branca leva um contorno da cor do fundo, num tom mais escuro, para que o nome se leia bem.' }[lang] ||
          'La letra en blanco lleva un borde del color del fondo, en un tono más oscuro, para que el nombre se lea bien.';
        cLetra.appendChild(notaBlanco);
      }
      notaBlanco.hidden = !/^(blanco|white|branco)$/i.test(valor(cLetra));
    }

    function pintar() {
      avisoBlanco();
      if (modoLetra) { pintarLetra(); return; }
      if (/dise/i.test(valor(tipo))) {
        /* Diseño: se enseña la foto de ejemplo de ese diseño y la galería salta a ella */
        var d = valor(diseno), ej = d && fotoDiseno(d);
        card.hidden = !ej;
        if (!ej) return;
        foto.src = (ej.currentSrc || ej.src);
        foto.hidden = false; svg.style.display = 'none';
        card.classList.add('is-foto');
        titulo.textContent = ((window.pawfyT || {}).diseno || 'Diseño') + ' ' + d;
        aviso.textContent = ((window.pawfyT || {}).disenoTxt || 'Así queda este fondo. La foto y el nombre serán los de tu peludo.');
        if (d !== ultimo) {
          ultimo = d;
          var g = document.querySelector('media-gallery'), li = ej.closest('[data-media-id]');
          if (g && g.setActiveMedia && li) g.setActiveMedia(li.dataset.mediaId, false);
          card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop');
        }
        return;
      }
      ultimo = '';
      card.hidden = false;
      foto.hidden = true; svg.style.display = '';
      card.classList.remove('is-foto');
      titulo.textContent = raza ? ((window.pawfyT || {}).chapaTit || 'Mira cómo queda tu chapa') : ((window.pawfyT || {}).colorTit || 'Mira cómo queda el color');
      aviso.textContent = raza ? ((window.pawfyT || {}).chapaTxt || 'Vista previa orientativa del color y el dibujo que elijas.') : ((window.pawfyT || {}).colorTxt || 'Vista previa orientativa del color de fondo que elijas.');
      var hueso = /hueso/i.test(valor(forma));
      /* El color sale del propio círculo (así funciona aunque el valor sea un nombre como "Rosa") */
      var marcado = color.querySelector('input:checked'), circulo = marcado && marcado.nextElementSibling;
      var hex = (circulo && circulo.style.backgroundColor) || valor(color) || '#141414', nom = esc((valor(nombre, 'input[type=text]') || 'Chloe').slice(0, 12));
      /* Hueso como el de las fotos: dos bolas a cada lado, centro estrechado y agujero arriba en el centro */
      var silueta = hueso
        ? '<circle cx="50" cy="84" r="34"/><circle cx="50" cy="146" r="34"/><circle cx="190" cy="84" r="34"/><circle cx="190" cy="146" r="34"/>' +
          '<path d="M44 66C90 84 150 84 196 66L196 164C150 146 90 146 44 164Z"/>'
        : '<circle cx="120" cy="122" r="82"/><circle cx="120" cy="36" r="24"/><rect x="96" y="36" width="48" height="40"/>';
      var agujero = hueso ? '<circle cx="120" cy="90" r="7" fill="#fff" stroke="rgba(0,0,0,.18)"/>' : '<circle cx="120" cy="34" r="9" fill="#fff" stroke="rgba(0,0,0,.18)"/>';
      var tam = hueso ? (nom.length > 7 ? 24 : 32) : (nom.length > 7 ? 26 : 36);
      var y = hueso ? 130 : 134, x = 120, dibujo = '';
      /* Chapa con dibujo: el dibujo de la raza elegida, recortado (sin el blanco de alrededor) encima del color */
      var rz = raza && raza.querySelector('input:checked'), rzImg = rz && rz.nextElementSibling;
      var url = rzImg && /url\(["']?([^"')]+)/.exec(rzImg.style.background || rzImg.style.backgroundImage || '');
      if (url) {
        var original = url[1].replace(/width=\d+/, 'width=400').replace(/height=\d+/, 'height=400');
        var limpio = sinFondo[original];
        if (!limpio) quitarBlanco(original, pintar);
        if (limpio) {
          dibujo = hueso
            ? '<image href="' + limpio + '" x="34" y="80" width="72" height="72" preserveAspectRatio="xMidYMid meet"/>'
            : '<image href="' + limpio + '" x="72" y="108" width="96" height="96" preserveAspectRatio="xMidYMid meet"/>';
        }
        if (hueso) { x = 152; y = 124; tam = nom.length > 6 ? 18 : 24; }
        else { y = 100; tam = nom.length > 7 ? 24 : 32; }
      }
      svg.innerHTML =
        '<g class="pawfy-chapa__forma" fill="' + hex + '">' + silueta + '</g>' + agujero + dibujo +
        '<text x="' + x + '" y="' + y + '" text-anchor="middle" class="pawfy-chapa__nom" style="font-size:' + tam + 'px">' + nom + '</text>';
      card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop');
    }

    var box = ancla.closest('.ymq-box') || document;
    box.addEventListener('change', function () { setTimeout(pintar, 30); }, true);
    box.addEventListener('input', function () { setTimeout(pintar, 30); }, true);
    box.addEventListener('click', function () { setTimeout(pintar, 60); }, true);
    pintar();
  }

  /* La app vuelve a dibujar sus fotos (al cargar tarde o al cambiar el tamaño), así que se vigila siempre */
  setInterval(instaTira, 800);
  setInterval(fotosAlternas, 2000);
  /* Las opciones de la app de chapas se dibujan tarde: se vigila hasta que aparecen */
  setInterval(chapaPrevia, 1000);

  function init() { recoger(); mover(); trazos(); pistaCategorias(); fotosAlternas(); setTimeout(function () { recoger(); trazos(); }, 1500); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
